{
  "slug": "how-can-i-find-out-my-iq",
  "title": "¿Cómo puedo saber mi coeficiente intelectual?",
  "description": "Compare las pruebas de coeficiente intelectual en línea con la evaluación profesional supervisada y aprenda a obtener e interpretar una puntuación cognitiva creíble.",
  "summary": "La forma correcta de averiguar su CI depende del propósito: un examen en línea cuidadoso puede proporcionar una estimación indicativa, mientras que las decisiones clínicas, educativas o de elegibilidad requieren una evaluación supervisada adecuada.",
  "category": "IQ essentials",
  "sections": [
    {
      "heading": "Comience con la razón por la que desea una puntuación",
      "paragraphs": [
        "La curiosidad, la práctica, la planificación educativa, la evaluación clínica y la calificación de membresía son objetivos diferentes.Una estimación informal en línea puede responder a una pregunta de curiosidad, pero no puede sustituir a un instrumento profesional protegido.",
        "Si el resultado puede afectar el tratamiento, las adaptaciones, la escolarización, el empleo o una solicitud formal, pregunte a un psicólogo calificado o a la organización pertinente qué prueba y documentación aceptan."
      ]
    },
    {
      "heading": "Qué buscar en una prueba en línea",
      "paragraphs": [
        "Una prueba en línea responsable explica qué muestra, cuánto tiempo toma, cómo se producen las puntuaciones de comparación y qué no puede establecer, debe proteger los datos personales y evitar reclamar un diagnóstico o una precisión garantizada.",
        "Realice la evaluación cuando esté descansado, use un ambiente tranquilo, siga las reglas de cronometraje y evite la ayuda externa.Repetir los mismos elementos puede crear efectos de práctica, por lo que un resultado posterior no es automáticamente una mejor estimación."
      ]
    },
    {
      "heading": "Lo que añaden las pruebas profesionales",
      "paragraphs": [
        "Una evaluación profesional utiliza una administración estandarizada, materiales seguros, normas de edad apropiadas, múltiples subpruebas y observaciones de comportamiento, y el informe resultante puede incluir puntajes de índice, intervalos de confianza e interpretación de diferencias significativas.",
        "Pregunte por el nombre del instrumento y la edición, el grupo de normas, el tipo de puntuación, el intervalo de confianza y los límites.Conserve el informe original si más tarde necesita prueba de un resultado calificado."
      ]
    }
  ],
  "faqs": [
    {
      "question": "¿Puede un test en línea gratuito decirme mi coeficiente intelectual exacto?",
      "answer": "Puede proporcionar una estimación indicativa si está bien diseñado, pero no puede establecer una puntuación exacta, permanente o clínica."
    },
    {
      "question": "¿Quién puede administrar un test de CI oficial?",
      "answer": "Los requisitos varían según el país y el instrumento, pero las pruebas clínicas estandarizadas suelen ser administradas e interpretadas por profesionales debidamente cualificados."
    }
  ],
  "related": ["is-an-online-iq-test-accurate", "how-is-iq-measured", "free-online-iq-test-guide"],
  "sources": [
    {
      "label": "Diccionario de Psicología de la APA — prueba de inteligencia",
      "url": "https://dictionary.apa.org/intelligence-test"
    },
    {
      "label": "Pearson — WAIS-5 Informe de puntuación de muestra",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    },
    {
      "label": "Mensa International — hacerse una prueba de coeficiente intelectual",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
